<template>
  <!-- header start from here -->

  <nav id="docs-sidebar"
  class="hs-accordion-group py-2 hs-overlay hs-overlay-open:translate-x-0 -translate-x-full transition-all duration-300 transform hidden left-0 bottom-0 z-[60] bg-white border-r border-gray-200 pt-7 lg:block lg:translate-x-0 lg:right-auto lg:bottom-0 dark:scrollbar-y dark:bg-gray-800 dark:border-gray-700 border-l-2 border-gray-100 min-h-full flex flex-col justify-between">
    <!-- conversation start from here  -->
    <div class="mx-3 mb-4 mt-2">
      <div class="flex justify-between">
        <div>Conversation</div>
        <!-- select dropdown menu start here -->
        
          <div class="ml-3 relative ">
                  <jet-dropdown align="right" > 
                    <template #trigger>

                      <span class="inline-flex rounded-md">
                        <button
                          type="button"
                          class="
                            inline-flex
                            items-center
                            text-sm
                            leading-4
                            font-medium
                            rounded-md
                            text-gray-500
                            bg-white
                            hover:text-gray-700
                            focus:outline-none
                            transition"
                        >
                          <!-- {{ $page.props.user.name }} -->

                          <img :src="'/imgs/More.png'" alt="logo" class="pngs" />
                        </button>
                      </span>
                    </template>

                    <template #content>
                     
                      <!-- Authentication -->
                      <form @submit.prevent="logout">
                        <jet-dropdown-link
                        href="/interface/settings"
                         >
                          setting
                        </jet-dropdown-link>
                        <jet-dropdown-link as="button">
                          Support
                        </jet-dropdown-link>
                        <jet-dropdown-link as="button">
                          License
                        </jet-dropdown-link>
                        <jet-dropdown-link as="button" @click="openNewChat" >
                          New Chat
                        </jet-dropdown-link>
                      </form>
                    </template>
                  </jet-dropdown>
          </div>
        
        <!-- select dropdown end -->
      </div>
    </div>
    <!-- conversation end -->

    <!-- Mobile no dropdown start -->
    <div class="mx-3">
    <div class="relative">
      <select
        v-model="selectedMobile"
        class="mt-1 block w-full border border-gray-300 rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-500 shadow-sm focus:outline-none focus:ring focus:border-blue-300"
      >
        <option value="+911234567890">+91 1234567890</option>
        <option value="+911234567890">+91 1234567890</option>
        <option value="+910987654321">+91 0987654321</option>
        <option value="+917890654321">+91 7890654321</option>
      </select>
      <div class="absolute inset-y-0 right-0 flex items-center px-2 pointer-events-none">
        <!-- <svg  class="ml-2 -mr-0.5 h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
          fill="currentColor">
          <path fill-rule="evenodd"
            d="M10 3a1 1 0 01.707.293l3 3a1 1 0 01-1.414 1.414L10 5.414 7.707 7.707a1 1 0 01-1.414-1.414l3-3A1 1 0 0110 3zm-3.707 9.293a1 1 0 011.414 0L10 14.586l2.293-2.293a1 1 0 011.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z"
            clip-rule="evenodd"></path>
        </svg> -->
      </div>
    </div>
  </div>
    <!-- mobile no. dropdown end -->

    <!-- searchbox start -->
    <div class="m-3">
      <div class="relative max-w-sm mx-auto">
          <input class="w-full h-9 py-2 border  border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500" type="search" placeholder="Search...">
      </div>
    </div>
    <!-- searchbox end -->

    <ul class="space-y-1 overflow-y-auto h-[28rem] scrollbar-y">
  <li class="hs-accordion" id="users-accordion">
    <span
    class="hs-accordion-toggle position-sticky flex items-center py-2 pad hs-accordion-active:text-blue-600 hs-accordion-active:hover:bg-transparent text-md text-gray-600 rounded-md dark:text-gray-500 dark:hover:text-gray-300 dark:hs-accordion-active:text-white no-underline "
    href="javascript:;"
    @click="toggleAccordion('users-accordion')"
  >
      Conversations
      <i class="fa fa-angle-down hs-accordion-active:block ml-auto hidden w-3 h-3 text-gray-600 group-hover:text-gray-500 dark:text-gray-400" aria-hidden="true"></i>
    </span>

    <div :id="'users-accordion'" class="hs-accordion-content w-full  transition-[height]" :class="{ 'hidden': !accordions['users-accordion'] }">
      <ul class="pt-2 h-[500px] max-h-[500px] overflow-y-auto">
        <li v-for="(item, list) in unreadList" :key="list" @click="selectUnreadItem(item)"@contextmenu.prevent="openContextMenu($event, item,index)"class="relative hover:bg-gray-100">
          <div>
            <div class="flex justify-between items-center p-2">
              <div class="flex justify-between space-x-2">
                <div>
                  <img class="rounded-full w-9" src="https://randomuser.me/api/portraits/med/men/75.jpg" alt="" />
                </div>
                <div class="flex flex-col ml-3 cursor-pointer hover:text-gray-800">
                  <p class="text-black-500 text-sm font-semibold cursor-pointer hover:text-gray-800">{{ item.name }}</p>
                  <p class="text-black-500 text-sm font-semibold cursor-pointer hover:text-gray-800">{{ item.participant_2_phone_no }}</p>
                  <p v-if="item.type === 'text'"
                    :class="{ 'text-xs text-blue-500': !item.status, 'text-xs text-blue-800 font-medium': item.status }"
                    class="truncate-text">
                    {{ item.message_content }}
                  </p>
                  <p v-else-if="item.type === 'image'"
                    :class="{ 'text-xs text-blue-500': !item.status, 'text-xs text-blue-800 font-medium': item.status }"
                    class="truncate-text">
                    {{ item.type }}
                  </p>
                  <p v-else="item.type === 'document'"
                    :class="{ 'text-xs text-blue-500': !item.status, 'text-xs text-blue-800 font-medium': item.status }"
                    class="truncate-text">
                    {{ item.document_name }}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div
              v-if="contextMenu.visible && contextMenu.item === item"
              :style="{ top: `${contextMenu.y}px`, left: `${contextMenu.x}px`}"
              class="absolute z-10 bg-white shadow-lg rounded-md py-1 w-32"
            >
              <button @click="deleteconversation(item)" class="block w-full text-left px-4 py-1 text-gray-700 hover:bg-gray-100">
                Delete conversations
              </button>
              <button @click="deletemessages(item)" class="block w-full text-left px-4 py-1 text-gray-700 hover:bg-gray-100">
                Delete Messages
              </button>
              <button @click="pinChat(item)" class="block w-full text-left px-4 py-1 text-gray-700 hover:bg-gray-100">
                Pin to top
              </button>
              <button @click="closelist(item)" class="block w-full text-left px-4 py-1 text-gray-700 hover:bg-gray-100">
                close
              </button>
            </div>
        </li>
      </ul>
    </div>
  </li>
</ul>


  </nav>
  <div v-if="showNewChatModal" class="fixed inset-0 z-10 flex items-center justify-center" >
    <div class="bg-white rounded-lg shadow-lg p-6 w-full max-w-md">
      <div class="flex justify-between mb-4">
        <h2 class="text-lg font-semibold">Search Contacts</h2>
        <button @click="closeNewChatModal" class="text-gray-500 hover:text-gray-800">
          <i class="fa fa-times"></i>
        </button>
      </div>
      
      <!-- Search bar -->
      <div class="relative mb-4">
        <input
          v-model="searchQuery"
          type="text" 
          placeholder="Search contacts..."
          class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring focus:border-blue-500"
        />
      </div>

      <!-- New Chat option -->
      <ul class="max-h-60 overflow-y-auto">
        <li 
          class="flex items-center justify-between p-2 hover:bg-gray-100 cursor-pointer" 
          @click="openStartChatModal"
        >
          New Chat
        </li>
      </ul>
    
      <!-- Contact list -->
      <ul class="max-h-40 overflow-y-auto" v-if="filteredContacts.length">
        <li
          v-for="contact in filteredContacts"
          :key="contact.id"
          @click="selectContact(contact)" 
          class="flex items-center justify-between p-2 hover:bg-gray-100 cursor-pointer"
        >
            <div>
              <p class="text-gray-700">{{ contact.name }}</p>
              <p class="text-sm text-gray-500">{{ contact.wa_phone_number }}</p>
            </div>
          
        </li>
      </ul>
      <div v-else-if="searchQuery && !contactFound">
        <p>No contacts found</p>
      </div>
    </div>
  </div>

  <!-- Second modal (Start Chat) -->
  <div v-if="showStartChatModal" class="fixed inset-0 z-50 flex items-center justify-center" style="margin-top:-400px; margin-left:400px">
    <div class="bg-white rounded-lg shadow-lg p-6 w-full max-w-md">
      <div class="flex justify-between mb-4">
        <h2 class="text-lg font-semibold">Start Chat</h2>
        <button @click="closeStartChatModal" class="text-gray-500 hover:text-gray-800">
          <i class="fa fa-times"></i>
        </button>
      </div>
      
      <!-- Textbox and Start Chat button -->
      <div class="mb-4">
        <input
          v-model="newChatText"
          type="text"
          placeholder="Enter your phone no."
          class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring focus:border-blue-500"
        />
      </div>
      <button 
        @click="startChat(newChatText)" 
        class="w-full px-3 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600"
      >
        Start Chat
      </button>
    </div>
  </div>


  <!-- header end -->
</template>
 
<script>
import AppLayout from "@/Layouts/AppLayout.vue";
import NavBar from "@/Layouts/NavBar.vue";
import JetResponsiveNavLink from "@/Jetstream/ResponsiveNavLink.vue";
import JetSideLink from "@/Jetstream/SideLink.vue";
import JetDropdown from "@/Jetstream/Dropdown.vue";
import JetDropdownLink from "@/Jetstream/DropdownLink.vue";
import { ref, watch } from 'vue';

export default {
  props: {
    selectedId: String,
    selectedType: String,
    item:{
      type:Object
    },
  
  },
  components: {
    AppLayout,
    NavBar,
    JetResponsiveNavLink,
    JetSideLink,
    JetDropdown,
    JetDropdownLink
  },
  data() {
    return {
  contextMenu : ref({
  visible: false,
  x: 0,
  y: -20,
  item: null,
}),
openContextMenu(event, item, index) {
  this.clickedElement = event.target.closest('li');  // Save clickedElement to this.clickedElement
  const { top: elementTop, left: elementLeft } = this.clickedElement.getBoundingClientRect();

  this.contextMenu = {
    visible: true,
    x: event.clientX - elementLeft,
    y: event.clientY - elementTop,
    item,
  };
  
  console.log(item);  // Now it should log the element as expected
},

      contactList: [],
      showNewChatModal : ref(true),
      showStartChatModal : ref(false),
      unreadList: ref([]) ,
      showNewChatModal : false,
      selectedMobile: "+911234567890",
      showOptions: false,
      noOptions: false,
      accordions: {
        'users-accordion': true, 
      },
      

     
      messagesList: [
        {
          title: 'Tarun Sir',
          info: 'Product Info',
          image: 'https://randomuser.me/api/portraits/med/men/75.jpg',
          time: '11:30AM',
          count: 2,
          status: false,
          phone_no: '0987654321',
        },
        {
          title: 'Saurabh Sir',
          info: 'Product Info',
          image: 'https://randomuser.me/api/portraits/med/men/75.jpg',
          time: '11:30AM',
          count: 3,
          status: false,
          phone_no: '0987654322',
        },
        {
          title: 'Sneha',
          info: 'Product Info',
          image: 'https://randomuser.me/api/portraits/med/men/75.jpg',
          time: '11:30AM',
          count: 2,
          status: false,
          phone_no: '0987654323',
        },
        {
          title: 'Tarun Sir',
          info: 'Product Info',
          image: 'https://randomuser.me/api/portraits/med/men/75.jpg',
          time: '11:30AM',
          count: 2,
          status: false,
          phone_no: '0987654321',
        },
        {
          title: 'Saurabh Sir',
          info: 'Product Info',
          image: 'https://randomuser.me/api/portraits/med/men/75.jpg',
          time: '11:30AM',
          count: 3,
          status: false,
          phone_no: '0987654322',
        },
        {
          title: 'Sneha',
          info: 'Product Info',
          image: 'https://randomuser.me/api/portraits/med/men/75.jpg',
          time: '11:30AM',
          count: 2,
          status: false,
          phone_no: '0987654323',
        },
        {
          title: 'Tarun Sir',
          info: 'Product Info',
          image: 'https://randomuser.me/api/portraits/med/men/75.jpg',
          time: '11:30AM',
          count: 2,
          status: false,
          phone_no: '0987654321',
        },
        {
          title: 'Saurabh Sir',
          info: 'Product Info',
          image: 'https://randomuser.me/api/portraits/med/men/75.jpg',
          time: '11:30AM',
          count: 3,
          status: false,
          phone_no: '0987654322',
        },
        {
          title: 'Sneha',
          info: 'Product Info',
          image: 'https://randomuser.me/api/portraits/med/men/75.jpg',
          time: '11:30AM',
          count: 2,
          status: false,
          phone_no: '0987654323',
        },
        {
          title: 'Tarun Sir',
          info: 'Product Info',
          image: 'https://randomuser.me/api/portraits/med/men/75.jpg',
          time: '11:30AM',
          count: 2,
          status: false,
          phone_no: '0987654321',
        },
        {
          title: 'Saurabh Sir',
          info: 'Product Info',
          image: 'https://randomuser.me/api/portraits/med/men/75.jpg',
          time: '11:30AM',
          count: 3,
          status: false,
          phone_no: '0987654322',
        },
        {
          title: 'Sneha',
          info: 'Product Info',
          image: 'https://randomuser.me/api/portraits/med/men/75.jpg',
          time: '11:30AM',
          count: 2,
          status: false,
          phone_no: '0987654323',
        },
        // Add more data items as needed
      ],
      searchQuery: '',
    };
  },
  computed: {
    filteredContacts() {
      return this.contactList.filter(contact =>
        contact.name.toLowerCase().includes(this.searchQuery.toLowerCase())
      );

    },
  },
  methods: {

  searchContacts(){
  contactFound.value = false; 
  filteredContacts.value = contacts.value.filter(contact => 
  contact.name.toLowerCase().includes(searchQuery.value.toLowerCase()) || 
  contact.number.includes(searchQuery.value)
  )
  contactFound.value = filteredContacts.value.length > 0;
},
      openStartChatModal(){
        this.showNewChatModal = false;
      this.showStartChatModal= true;
      },
     selectContact(contact){
     this.$emit('contactSelected', contact);   
   
     this.showNewChatModal = false;
    },

    closelist(item) {
      this.contextMenu.visible = false;
    },
    openNewChat() {
      this.showNewChatModal = true;
    },
    closeNewChatModal() {
      this.showNewChatModal = false;
      this.selectedContact = null;
    },

    closeStartChatModal()
    {
      this.showStartChatModal= false;
    },
    mobileOptions() {
      this.noOptions = !this.noOptions;
    },
    toggleOptions() {
      this.showOptions = !this.showOptions;
      
    },
    toggleSidebar() {
      this.isSidebarOpen = !this.isSidebarOpen;
  
    },
    toggleAccordion(accordionId) {
      this.accordions[accordionId] = !this.accordions[accordionId];
      
    },
    selectUnreadItem(item) {
      this.$emit('unread',item);   
    },

    async deleteconversation(item) {
    try {
        const phoneNo = item.participant_2_phone_no;
        if (!phoneNo) {
            console.error('Participant phone number is missing.');
            alert("Participant phone number is missing.");
            return;
        }
        console.log('Making request with phone number:', phoneNo);

        await axios.post('/all/conversation/con-soft-delete', { participant_2_phone_no: phoneNo });
        this.contextMenu.visible = false;

        alert("Conversation soft deleted successfully.");
        this.fetchUnreadConversation();
        

    } catch (error) {
        console.error("Error soft deleting conversation:", error);
        alert("Failed to soft delete the conversation. Please try again.");
    }
},

 async deletemessages(item)
{
  try {
        const phoneNo = item.participant_2_phone_no;
        if (!phoneNo) {
            console.error('Participant phone number is missing.');
            alert("Participant phone number is missing.");
            return;
        }
        console.log('Making request with phone number:', phoneNo);

        await axios.post('/all/conversation/msg-soft-delete', { participant_2_phone_no: phoneNo });
        this.contextMenu.visible = false;

        alert("Messages soft deleted successfully.");
        this.fetchUnreadConversation();

    } catch (error) {
        console.error("Error soft deleting conversation:", error);
        alert("Failed to soft delete the conversation. Please try again.");
    }
},


    startChat(phoneNumber){
    if (!phoneNumber) {
    console.error('Phone number is required');
    return;
  }


      this.$emit('startchat',phoneNumber); 
    

    this.showStartChatModal= false;
    
   


},




 async fetchContacts(){
  axios.get('/all/conversation/fetchcontacts')
    .then(response => {
      this.contactList = response.data;
      console.log( this.contactList);
      
    })
    .catch(error => {
      console.error('Error fetching contacts:', error);
    });
    
},
  async fetchUnreadConversation() {
      try {
        const response = await axios.get('/all/conversation/list'); // Adjust the endpoint as needed
        this.unreadList = response.data;
        console.log( this.unreadList); // Assuming the response data is an array of unread messages
      } catch (error) {
        console.error('Error fetching unread messages:', error);
      }
    },

},

  mounted() {

    this.fetchUnreadConversation();
    this.fetchContacts();

    // js start
    // document.addEventListener('DOMContentLoaded', function () {
      // Users Dropdown
      // const usersAccordionToggle = document.querySelector('#users-accordion span.hs-accordion-toggle');
      // const usersAccordionContent = document.querySelector('#users-accordion .hs-accordion-content');

      // usersAccordionToggle.addEventListener('click', function () {
      //   usersAccordionContent.classList.toggle('hidden');
      // });

      // Account Dropdown
      const accountAccordionToggle = document.querySelector('#account-accordion span.hs-accordion-toggle');
      const accountAccordionContent = document.querySelector('#account-accordion .hs-accordion-content');

      // accountAccordionToggle.addEventListener('click', function () {
      //   // Toggle the 'hidden' class on the content to show/hide it
      //   accountAccordionContent.classList.toggle('hidden');
    //   });
    // });
    // js end
  // }

},



  }
  
</script>
 
<style>
.pad {
  padding: 0 20px;
}

.logo {
  width: 50px;
}

p {
  margin-bottom: 0.8rem;
}
.text-xs{
  font-size: 0.75rem;
line-height: 1rem; 
}
.text-sm{
font-size: 0.875rem;
line-height: 1rem;
}
.position-sticky {
    position: sticky;
    top: 0; /* Adjust this value based on your design */
    z-index: 100; /* Adjust this value based on your design */
    background-color: #fff; /* Adjust this value based on your design */
  }
/* .pad:hover{
  border-left: 4px solid rgb(192, 191, 191);
} */
.pb-2{
  padding-bottom: .01rem !important;
}

.button {
  color: #007bff;
  background: none;
  border: none;
  cursor: pointer;
  text-decoration: underline;
}

.truncate-text {
  max-width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.custom-context-menu {
  width: 150px; /* Adjust this value to make the menu narrower */
}

.custom-context-menu li {
  padding: 8px 12px;
}

</style>